import { z } from 'zod';

const decimalString = z.string().regex(/^-?\d+(\.\d+)?$/, 'invalidDecimal');

export const PaymentIdSchema = z.string().uuid('invalidUuid');

export const PaymentFormatValues = [
  'SWIFT_MT103',
  'SWIFT_MT202',
  'SWIFT_MT192',
  'ISO20022_MX',
  'RTGS',
  'INTERNAL',
] as const;

export const PaymentFormatSchema = z.enum(PaymentFormatValues);

export type PaymentFormat = z.infer<typeof PaymentFormatSchema>;

export const PaymentLifecycleValues = [
  'generated',
  'sent',
  'acknowledged',
  'rejected',
  'cancelled',
] as const;

export const GeneratePaymentFormSchema = z.object({
  settlement_id: PaymentIdSchema,
  format: PaymentFormatSchema,
});

export type GeneratePaymentForm = z.infer<typeof GeneratePaymentFormSchema>;

export const GeneratePaymentPayloadSchema = z.object({
  settlement_id: PaymentIdSchema.optional(),
  format: PaymentFormatSchema.optional(),
});

export type GeneratePaymentPayload = z.infer<typeof GeneratePaymentPayloadSchema>;

export const PaymentDetailPayloadSchema = z.object({
  payment_id: PaymentIdSchema,
});

export type PaymentDetailPayload = z.infer<typeof PaymentDetailPayloadSchema>;

export const PaymentMessageResponseSchema = z.object({
  id: PaymentIdSchema,
  settlement_id: PaymentIdSchema,
  format: z.string().min(1),
  status: z.string().min(1),
  content: z.string(),
  external_reference: z.string().nullable().optional(),
  rejection_reason: z.string().nullable().optional(),
  cancellation_of_id: PaymentIdSchema.nullable().optional(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type PaymentMessageResponse = z.infer<typeof PaymentMessageResponseSchema>;

export const SettlementResponseSchema = z.object({
  id: PaymentIdSchema,
  deal_id: PaymentIdSchema,
  cashflow_id: PaymentIdSchema,
  counterparty_id: PaymentIdSchema,
  payment_date: z.string(),
  amount: decimalString,
  currency: z.string(),
  direction: z.string(),
  status: z.string(),
  ssi_id: PaymentIdSchema.nullable().optional(),
  external_reference: z.string().nullable().optional(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type SettlementResponse = z.infer<typeof SettlementResponseSchema>;
